import { validate } from 'rut.js';
import { object, string } from 'yup';

import {
  type IdentificationDocumentType,
  IdentificationDocumentTypes
} from '@/modules/shared/types/IdentificationDocumentType';

export interface IPickupId {
  fullname: string;
  documentType: IdentificationDocumentType;
  documentID: string;

  // @deprecated - Keep for backward compatibility
  rut?: string;
}

export interface IPickupIdForm extends IPickupId {}

export const PICKUP_FULL_NAME_MAX_LENGTH = 65;

/**
 * Factory function to create pickup ID form schema with dynamic DNI validation.
 * @param isDniEnabled - Whether DNI validation should be enabled (based on user type and feature flags)
 */
export const getPickupIdFormSchema = (isDniEnabled: boolean) =>
  object().shape({
    fullname: string()
      .required('Campo obligatorio')
      .max(
        PICKUP_FULL_NAME_MAX_LENGTH,
        `El nombre y apellido no puede exceder los ${PICKUP_FULL_NAME_MAX_LENGTH} caracteres.`
      ),

    documentType: string()
      .required('Campo obligatorio.')
      .oneOf(
        isDniEnabled
          ? [IdentificationDocumentTypes.RUT, IdentificationDocumentTypes.DNI]
          : [IdentificationDocumentTypes.RUT],
        'Tipo de documento inválido'
      ),

    documentID: string()
      .required('Campo obligatorio.')
      .when('documentType', {
        is: IdentificationDocumentTypes.RUT,
        then: (schema) =>
          schema
            .min(11, 'El RUT ingresado no es válido.')
            .max(12, 'El RUT ingresado no es válido.')
            .test('is-rut-valid', 'El RUT ingresado no es válido.', validate),
        otherwise: (schema) =>
          isDniEnabled
            ? schema
                .min(8, 'Por favor, ingresa un DNI válido.')
                .max(18, 'El documento debe tener máximo 18 caracteres.')
                .matches(
                  /^[A-Z0-9]+$/i,
                  'El documento solo puede contener letras y números.'
                )
            : schema.strip().notRequired()
      })
  });

// Backward compatibility: export default schema with DNI disabled
export const pickupIdFormSchema = getPickupIdFormSchema(false);
